"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cesana-torinese": {
    "2db3c762": [{
      "hkey": "3c6123de",
      "slug": "sagna-longa",
      "name": "Sagna Longa",
      "primary": true,
      "skipSearch": false
    }],
    "sagnalonga": [{
      "hkey": "3c6123de",
      "slug": "sagna-longa",
      "name": "Sagna Longa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3907cf26": [{
      "hkey": "3430f2ba",
      "slug": "san-sicario",
      "name": "San Sicario",
      "primary": true,
      "skipSearch": false
    }],
    "san-sicario-borgo": [{
      "hkey": "3430f2ba",
      "slug": "san-sicario",
      "name": "San Sicario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;